import { createMeta } from "../../../components/TapHeader";

const title = "Billing";
export const OrgBillingMeta = createMeta(title);
